import { Component, OnInit, Inject, Optional, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from '../../shared/services/language.service';

@Component({
  standalone: false,
  selector: 'app-add-region-dialog',
  templateUrl: './add-region-dialog.component.html',
  styleUrls: ['./add-region-dialog.component.css']
})

export class AddRegionDialogComponent implements OnInit {

  variables: any;
  local_data: any;
  invalidInput: boolean = false;
  errorMessage: string = '';
  formGroup1: any;
  regions: any = [];
  regionsFinal: any = [];
  filteredRegions: any = [];

  constructor(
    public dialogRef: MatDialogRef<AddRegionDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: FormBuilder,
    private languageService: LanguageService
  ) {
    this.local_data = { ...data };
  }

  ngOnInit(): void {

    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.formGroup1 = this._formBuilder.group({
      regionsFilterCtrl: [''],
      regionCtrl: ['', Validators.required]
    });

    this.regions = this.local_data.regions;
    this.filteredRegions = this.local_data.regions;

    this.formGroup1.get('regionsFilterCtrl').valueChanges.subscribe((value: any) => {
      this.filterRegions();
    })

  }

  filterRegions() {
    let search = this.formGroup1.get('regionsFilterCtrl').value;
    if (!search) {
      this.filteredRegions = (this.regions.slice());
      return;
    }
    else {
      search = search.toLowerCase();
    }

    this.filteredRegions = this.regions.filter((region: any) => region.name.toLowerCase().indexOf(search) > -1);
  }

  doAction() {
    const formGroup = this.formGroup1.value;
    let valid = true;

    /* Check if all the inputs have been filled. */
    if (!formGroup.regionCtrl) {
      this.invalidInput = true;
      this.errorMessage = this.variables.errorRegionName;
      valid = false;
    }
    else {
      this.invalidInput = false;
    }

    if (formGroup.regionsFilterCtrl) {
      this.local_data.region = formGroup.regionsFilterCtrl;
    }

    //Pass data
    if (valid) this.dialogRef.close({ data: formGroup.regionCtrl });
  }

}
